import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';
import { surpriseService } from '@/services/surprise';
import { useVuelidate } from '@vuelidate/core';
import { minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useSurpriseItemAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const categoryId = route.params.categoryId;

    const model = reactive({
        name: '',
        price: 0,
        isPublished: false,
        imageFile: null
    });

    const validations = {
        name: { required },
        price: { minValue: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const create = crudAction.excuteAndNotify({
        validator: v$,
        request: () =>
            surpriseService.item.create(model.name, categoryId, model.price, model.isPublished, model.imageFile),
        onSuccess: () => router.push({ name: ROUTE_NAME_SURPRISE.CATEGORY.ITEM.INDEX, params: { categoryId } })
    });

    return { model, v$, create };
}
